// @flow

import initialState from 'fc-assets/src/initialState'
export default initialState
